<script setup lang="ts">
import { AkAccountNav } from '@ankorstore/design-system';
import { useAccountMenu } from './../composables/use-account-menu';
import { useAccountMenuHighlight } from './../composables/use-account-menu-highlight';
import AnkorstorePlusBadgeBrand from '@monolith/legacy/modules/promote-engage/subscription-program/UI/ankorstore-plus-badge-brand.vue';

interface Props {
  withExternalLink?: boolean;
  surface?: string;
}

const props = withDefaults(defineProps<Props>(), {
  withExternalLink: false,
  surface: 'sidebar',
});

const { items, getCurrentUrl, navigate } = useAccountMenu(props.withExternalLink, props.surface);
const { itemsWithHighlight, isAccountRoute, handleHighlightClosed } = useAccountMenuHighlight(items, getCurrentUrl);
</script>

<template>
  <AkAccountNav
    v-if="itemsWithHighlight.length && getCurrentUrl"
    :items="itemsWithHighlight"
    :url-active="getCurrentUrl"
    :all-closed="!isAccountRoute"
    :as-link="true"
    @navigation-clicked="navigate"
    @highlight-closed="handleHighlightClosed"
  >
    <template #icon-ankorstore-plus-badge>
      <slot name="icon-ankorstore-plus-badge">
        <AnkorstorePlusBadgeBrand :show-background="false" />
      </slot>
    </template>
    <template #tooltip-vat_settings>
      <slot name="tooltip-vat_settings" />
    </template>
  </AkAccountNav>
</template>

<style lang="scss" scoped>
:deep(.highlight-wrapper) {
  @apply ds-w-full;
}
</style>
